import React, { useCallback, useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
const purchases = [{
  name: 'María L.',
  city: 'Córdoba',
  product: 'Sistema Completo',
  time: 'hace 2 minutos'
}, {
  name: 'Javier R.',
  city: 'Mendoza',
  product: 'Sistema Premium',
  time: 'hace 5 minutos'
}, {
  name: 'Carolina S.',
  city: 'Rosario',
  product: 'Sistema Completo',
  time: 'hace 8 minutos'
}, {
  name: 'Martín G.',
  city: 'Neuquén',
  product: 'Sistema Premium',
  time: 'hace 12 minutos'
}, {
  name: 'Valeria P.',
  city: 'CABA',
  product: 'Sistema Completo',
  time: 'hace 15 minutos'
}, {
  name: 'Diego D.',
  city: 'Tucumán',
  product: 'Sistema Premium',
  time: 'hace 18 minutos'
}, {
  name: 'Sofía M.',
  city: 'La Plata',
  product: 'Sistema Completo',
  time: 'hace 22 minutos'
}, {
  name: 'Andrés A.',
  city: 'Salta',
  product: 'Sistema Premium',
  time: 'hace 25 minutos'
}];
export function PurchaseToast() {
  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const showToast = useCallback(() => {
    setDismissed(false);
    setVisible(true);
    const hideTimer = setTimeout(() => setVisible(false), 6000);
    return hideTimer;
  }, []);
  useEffect(() => {
    const initialTimer = setTimeout(() => showToast(), 8000);
    return () => clearTimeout(initialTimer);
  }, [showToast]);
  useEffect(() => {
    if (!visible && !dismissed) {
      const nextTimer = setTimeout(() => {
        setIndex(prev => (prev + 1) % purchases.length);
        showToast();
      }, 45000);
      return () => clearTimeout(nextTimer);
    }
  }, [visible, dismissed, showToast]);
  const handleDismiss = () => {
    setVisible(false);
    setDismissed(true);
    setTimeout(() => {
      setIndex(prev => (prev + 1) % purchases.length);
      setDismissed(false);
      showToast();
    }, 45000);
  };
  const purchase = purchases[index];
  return <div className={`fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-sm transition-all duration-500 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0 pointer-events-none'}`} data-id="element-385">
      <div className="bg-white/95 backdrop-blur-md border border-slate-200 rounded-2xl p-5 shadow-soft-lg relative overflow-hidden" data-id="element-386">
        {/* Decorative edge */}
        <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-primary" data-id="element-387" />

        <div className="flex items-center justify-between mb-3" data-id="element-388">
          <div className="flex items-center gap-2" data-id="element-389">
            <span className="relative flex h-2.5 w-2.5" data-id="element-390">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75" data-id="element-391"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-primary" data-id="element-392"></span>
            </span>
            <span className="text-primary-dark text-[10px] font-extrabold uppercase tracking-widest" data-id="element-393">
              NUEVA FAMILIA UNIDA
            </span>
          </div>
          <button onClick={handleDismiss} className="text-slate-400 hover:text-slate-600 transition-colors p-1" aria-label="Cerrar" data-id="element-394">
            <XIcon className="w-4 h-4" data-id="element-395" />
          </button>
        </div>

        <p className="text-slate-900 text-sm mb-1" data-id="element-396">
          <span className="font-extrabold" data-id="element-397">{purchase.name}</span>
          <span className="text-slate-500 font-medium" data-id="element-398">
            {' '}
            de {purchase.city}
          </span>
        </p>
        <p className="text-slate-600 text-sm" data-id="element-399">
          compró el{' '}
          <span className="text-amber-dark font-extrabold" data-id="element-400">
            {purchase.product}
          </span>
        </p>
        <p className="text-slate-400 text-xs mt-3 font-bold uppercase tracking-wider" data-id="element-401">
          {purchase.time}
        </p>
      </div>
    </div>;
}